import { render } from "./TestimonialsContent.vue?vue&type=template&id=271d6b31&scoped=true"
const script = {}

import "./TestimonialsContent.vue?vue&type=style&index=0&id=271d6b31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271d6b31"]])

export default __exports__